import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import * as actions from "../../../store/actions";
import {connect} from "react-redux";
import {onChangeInput, validateInputs, validatePassword} from "../../../services/utils";
import Alert from "../../../components/alert";
import Container from '@material-ui/core/Container';
import {Footer, InputRow} from '../../../components'
import {useStyles} from "./authStyles";
import {initialState} from "../signUp/constant";
import 'react-phone-number-input/style.css'
import {FormControl, FormControlLabel, InputLabel, Radio, RadioGroup} from "@material-ui/core";
import PhoneInput from 'react-phone-number-input'
import Header from './header'
// react-phone-number-input already bundles a full ISO-country-code -> English
// name map for its own phone-country dropdown (see the flag picker) — reused
// here for the country field instead of `marketplace/countriesList`, a
// legacy endpoint that only ever existed on a mock server and 404s against
// the real backend (the country/state/city dropdowns were unusable before
// this — see CHECKPOINT history).
import countryLabels from 'react-phone-number-input/locale/en.json'

const tradeRoles = ['buyer', 'seller', 'both']

// Pakistan pinned first since this marketplace's primary market.
const COUNTRY_OPTIONS = [
  {text: 'Pakistan', value: 'Pakistan'},
  ...Object.entries(countryLabels)
    .filter(([code]) => /^[A-Z]{2}$/.test(code))
    .map(([, name]) => name)
    .filter((name) => name !== 'Pakistan')
    .sort()
    .map((name) => ({text: name, value: name})),
];

function SignUp(props) {
  const classes = useStyles();
  const [state, setState] = useState(initialState);
  const {values, errors} = state;


  useEffect(() => {

    if (props.authReducer.error) {

      setTimeout(() => {
        props.errorHandlerSuccess();
      }, 5000);
    } else {
      console.log(" signup success in use effect ", props.authReducer.success)
      if (props.authReducer.success) {

        setState(initialState);
        setTimeout(() => {
          props.history.push("/signIn");
          props.errorHandlerSuccess();
        }, 5000);
      }
    }
  }, [props.authReducer.error, props.authReducer.success, props.authReducer.loading,]);

  const registerUser = (e) => {
    e.preventDefault();
    let {
      businessSelected,
      firstName,
      lastName,
      email,
      mobileNumber,
      password,
      confirmPassword,
      city,
      country,
      provider
    } = values;
    mobileNumber = mobileNumber.slice(1)
    // country/state/city are intentionally left out of required-field
    // validation: their dropdowns depend on a legacy endpoint that no longer
    // works (see checkpoint history), so requiring them would make signup
    // impossible to complete. The backend defaults organizationCountry when
    // it's left blank.
    let data = {
      businessSelected,
      firstName,
      lastName,
      email,
      mobileNumber,
      password,
      confirmPassword,
    };

    let recordedErrors = validateInputs(data);

    if (Object.keys(recordedErrors).length > 0) {
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let recordedErrors = {}
      // if (!validateEmail(email)) {
      //   recordedErrors.email = 'Invalid Email';
      //}
      let passwordCheck = validatePassword(password);
      if (passwordCheck) {
        recordedErrors.password = passwordCheck;
      } else if (password !== confirmPassword) {
        recordedErrors.confirmPassword = 'password mismatched';
        setState((prevState) => ({
          ...prevState,
          errors: recordedErrors,
        }));
      }
      if (Object.keys(recordedErrors).length > 0) {
        console.log("error", recordedErrors);
        setState((prevState) => ({
          ...prevState,
          errors: recordedErrors,
        }));
      } else {
        const data = {
          businessSelected,
          firstName,
          lastName,
          mobileNumber,
          email,
          password,
          confirmPassword,
          city,
          country,
          provider,
          signup: true
        };
        props.onSignUpHandler(data);
      }
    }
  };

  // See login.js for why this defaults to 'PK' instead of blank.
  const [country, setCountry] = useState('PK')

  const getData = async () => {
    fetch('https://geolocation-db.com/json/')
        .then((res) => res.json())
        .then(res => {
          // geolocation-db.com's response is flat ({country_code: "PK", ...}),
          // not nested under `.data` — the old `res?.data` check here always
          // failed, so this never actually ran; harmless by accident since it
          // meant the 'PK' default below was never overwritten, but fixing it
          // properly so a real detected country works too.
          if (res?.country_code) {
            setCountry(res.country_code)
          }}).catch(res=>console.log(res))
  }

  useEffect(() => {
    //passing getData method to the lifecycle method
    getData().then()

  }, []);


  const labelTypeOptions = [
    {text: 'MG', value: 'MG'},
    {text: 'Non-MG', value: 'Non-MG'},
    {text: 'N/A', value: 'N/A'},
    {text: 'All', value: 'all'},
  ]
  return (
    <>
      <Header/>
      {((props.authReducer?.error || props.authReducer?.success) && !props.authReducer?.loading) &&
      <Alert type={props.authReducer.error ? 'error' : 'success'}
             message={props.authReducer.error || props.authReducer.success}/>
      }
      <Container component="main" maxWidth="sm">
        <div className={classes.paper}>
          <form className={classes.form}>
            <InputRow
              types={[
                {value: values.firstName, error: errors.firstName, label: 'first Name', id: "firstName"},
                {value: values.lastName, error: errors.lastName, label: 'last Name', id: "lastName"},
              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={2}
            />
            <div className='pl-10'>
              <h4 className='in-active-color text-normal text-capitalize'>select trade role </h4>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={values.businessSelected}
                  onChange={(e) => {
                    e.preventDefault()
                    onChangeInput(e.target.value, 'businessSelected', state, setState)
                    // setLabelType(e.target.value)
                  }}
                  className={'text-capitalize'}
                >
                  {tradeRoles.map((item, index) => {
                    return (
                      <FormControlLabel value={item} control={<Radio/>} label={item}/>
                    )
                  })}
                </RadioGroup>
              </FormControl>
            </div>

            <div className='full-width mt-20'>

              <InputRow
                types={[
                  {
                    type: 'select',
                    value: values.country,
                    error: errors.country,
                    label: 'country',
                    id: 'country',
                    dropdownList: COUNTRY_OPTIONS,
                    required: false,
                  }, {
                    value: values.state,
                    error: errors.state,
                    label: 'state / province',
                    id: 'state',
                    required: false,
                  }, {
                    value: values.city,
                    error: errors.city,
                    label: 'city name',
                    id: 'city',
                    required: false,
                  }
                ]}
                onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                numOfInputPerRow={3}
              />
            </div>
            <div className=''>
              <div className='full-width p-20'>
                <InputLabel error={errors.mobileNumber ? true : false}>Phone Number</InputLabel>
                <PhoneInput
                  international
                  style={{border: 'none'}}
                  className='country-number'
                  placeholder="Enter phone number"
                  value={values.mobileNumber}
                  onChange={(value, key) => {
                    onChangeInput(value, `mobileNumber`, state, setState)
                  }}
                  defaultCountry={country}
                />
              </div>
              <InputRow
                types={[

                  {value: values.email, error: errors.email, label: 'email'},

                ]}
                onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                numOfInputPerRow={1}
              />
              <div className='mt-20'>
                <InputRow
                  types={[

                    {type: 'password', value: values.password, error: errors.password, label: 'password',},
                    {
                      type: 'password',
                      value: values.confirmPassword,
                      error: errors.confirmPassword,
                      label: 'Confirm Password',
                      id: 'confirmPassword',
                    },
                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={2}
                />
              </div> <div className='mt-20'>
                <InputRow
                  types={[

                    {value: values.provider, error: errors.provider, label: 'Company Name', id: 'provider'},
                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={1}
                />
              </div>
            </div>
            <Grid container spacing={2} className='mt-10 mb-20 pl-10  pr-10'>
              <Grid item lg={12} xs={12}>
                <Button type="submit" fullWidth variant="contained" color="primary"
                  // onClick={() => login()}
                        onClick={registerUser}
                >
                  agree to register
                </Button>
              </Grid>
              <Grid item lg={12} xs={12} className='text-center'>
                <h2 className='m-10'> OR</h2>
              </Grid>
              {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  className={classes.fbBtn}
                  // onClick={() => googleLogin()}

                >
                  register with
                  <span className='font-16 text-bold ml-5 text-lowercase'>{'  '} f</span>
                </Button>
              </Grid> */}
              {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  // color="primary"
                  className={classes.googleBtn}
                  // onClick={() => googleLogin()}
                >
                  register with
                  <span className='font-16 text-bold ml-5'>{'  '} G+</span>
                </Button>
              </Grid> */}

              <Grid container>
                <Grid item xs>
                  {/*<Link href="#" variant="body2">*/}
                  {/*  Forgot password?*/}
                  {/*</Link>*/}
                </Grid>
                <Grid item>
                  <Link href="/signIn" variant="body2" className='heading-color'>
                    {"Already have an account? Sign In"}
                  </Link>
                </Grid>
              </Grid>

            </Grid>
          </form>
        </div>
      </Container>
      <Footer auth={true}/>
    </>
  );
}

const mapStateToProps = ({authReducer}) => {
  return {authReducer};
};
const mapDispatchToProps = (dispatch) => {
  return {
    onSignUpHandler: (data) => dispatch(actions.signupStart(data)),
    errorHandlerSuccess: () => dispatch(actions.loginErrorHandlerSuccess()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignUp);

